import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { UserInfoService, GetToken } from '../services/security.service';
import { Observable, catchError, map, of } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { CssVarsService } from '../services/css-vars.service';
import { LanguageService } from '../services/language.service';
import { GenericClass } from '../interfaces';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root',
})
export class FetchToken {
  public token: string = '';
  public companycode: string = '';
  public externalUserId: string = '';
  public logintype: string = '';
  public externalUrl: string = '';
  public previousCompanyCode: string = '';
  public tempToken: string = '';
  public companyDetails: any;
  public isMultiBranding: string | boolean = false;
  public selectedBrand: string = '';
  public cookieClientCode: string = '';
  public queryParamCompanycode: string = '';
  public userInfo: any = {};

  constructor(
    private router: Router,
    private userInfoService: UserInfoService,
    private getToken: GetToken,
    private sharedService: SharedService,
    private cssVarsService: CssVarsService,
    private languageService: LanguageService,
    private configService: ConfigService
  ) {
    this.userInfo = this.userInfoService.get();
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    let updatedUrl: string = window.location.href;

    // Check if the URL contains 'amp;' and replace it
    if (updatedUrl.includes('amp;')) {
      updatedUrl = updatedUrl.replace(/amp;/g, '');

      // Reload the application with the corrected URL
      window.location.href = updatedUrl;
      return false; // Stop further execution as the page is reloading
    }

    const queryToken =
      route.queryParams['jwtToken'] || route.queryParams['JwtToken'];
    this.userInfoService.jwtToken = queryToken
      ? decodeURIComponent(queryToken)
      : '';
    this.companycode =
      route.queryParams['companycode'] ||
      route.queryParams['orgid'] ||
      this.sharedService.getCookie('clientCode');
    this.token =
      this.sharedService.getCookie('token') || this.userInfoService.jwtToken;
    this.externalUserId = '';
    this.logintype = '';
    this.externalUrl = '';
    this.isMultiBranding = false;
    this.selectedBrand = '';
    this.queryParamCompanycode = '';
    this.cookieClientCode = this.sharedService.getCookie('clientCode') ?? '';

    let urlQueryParamsObj = JSON.parse(JSON.stringify(route.queryParams));
    if (urlQueryParamsObj && Object.keys(urlQueryParamsObj).length > 0) {
      let paramKeyToCompare: string = '';
      for (let key in urlQueryParamsObj) {
        paramKeyToCompare = key?.replace(/amp;/g, '')?.toLowerCase();

        if (paramKeyToCompare === 'externaluserid') {
          this.externalUserId = urlQueryParamsObj[key];
        } else if (paramKeyToCompare === 'logintype') {
          this.logintype = urlQueryParamsObj[key];
        } else if (paramKeyToCompare === 'url') {
          this.externalUrl = urlQueryParamsObj[key];
        } else if (paramKeyToCompare === 'companycode') {
          this.companycode = urlQueryParamsObj[key];
          this.queryParamCompanycode = urlQueryParamsObj[key] ?? '';
        } else if (paramKeyToCompare === 'ismultibrand') {
          this.isMultiBranding = urlQueryParamsObj[key];
        } else if (paramKeyToCompare === 'selectedbrand') {
          this.selectedBrand = urlQueryParamsObj[key];
        } else if (paramKeyToCompare === 'workspace') {
          this.selectedBrand = urlQueryParamsObj[key];
          this.isMultiBranding = 'true';
        }
      }
    }

    if (this.token) {
      if (
        this.isMultiBranding &&
        (this.isMultiBranding == '1' ||
          (typeof this.isMultiBranding === 'string' &&
            this.isMultiBranding.toLowerCase() == 'true'))
      ) {
        if (
          this.cookieClientCode.toLowerCase() !=
            this.selectedBrand.toLowerCase() &&
          this.cookieClientCode.toLowerCase() !=
            this.queryParamCompanycode.toLowerCase()
        ) {
          let clientCodeToSend: string = this.selectedBrand
            ? this.selectedBrand
            : this.queryParamCompanycode;
          return this.validateCompanyCode(clientCodeToSend);
        } else {
          let returnToUrl: string =
            window.location.origin +
            window.location.pathname +
            encodeURIComponent(window.location.search);

          if (this.selectedBrand) {
            if (
              this.cookieClientCode.toLowerCase() ===
              this.selectedBrand.toLowerCase()
            ) {
              return this.fetchToken(this.selectedBrand);
            } else {
              return false;
            }
          } else {
            let queryParamsObj: any = {
              returnToUrl: returnToUrl,
              selectedBrand: this.companycode,
            };

            this.router.navigate(['brand'], { queryParams: queryParamsObj });
            return false;
          }
        }
      } else {
        return this.fetchToken();
      }
    } else {
      let conpanyCodeToSend = this.companycode;
      if (
        this.isMultiBranding &&
        (this.isMultiBranding == '1' ||
          (typeof this.isMultiBranding === 'string' &&
            this.isMultiBranding?.toLowerCase() == 'true')) &&
        this.selectedBrand
      ) {
        conpanyCodeToSend = this.selectedBrand;
      }

      if (conpanyCodeToSend) {
        if (!this.externalUserId) {
          GenericClass.setCookie('companycode', conpanyCodeToSend, 7);
        }
        return this.validateCompanyCode(conpanyCodeToSend);
      } else {
        const returnUrl = encodeURIComponent(window.location.href);
        const loginUrl = `${this.configService.getApiUrl(
          'ssoUrl'
        )}account/login?returnUrl=${returnUrl}`;

        window.location.replace(loginUrl);
        return false;
      }
    }
  }

  private goToDefaultUrl(): void {
    const locationUrl: string = window.location.href.replace(/\/$/, '');
    const defaultReturnUrl: string | null =
      GenericClass.getCookie('defaultreturnurl');
    const hubAppUrl: string = this.configService
      .getApiUrl('hubAppUrl')
      .replace(/\/$/, '');
    const devJobRockUrl: string = 'https://dev.jobrock.com:4202';
    if (
      defaultReturnUrl &&
      (locationUrl === hubAppUrl || locationUrl === devJobRockUrl)
    ) {
      window.location.replace(defaultReturnUrl);
    }
  }

  validateCompanyCode(companycode: string): boolean {
    var baseURL = location.href.split('?');
    let encodedUrl = baseURL[0];

    if (baseURL.length > 1) {
      baseURL[1].split('&').map((item: string, index: number) => {
        if (item?.toLowerCase().indexOf('companycode') >= 0) {
          item = `companycode=${companycode}`;
        }

        if (index === 0) {
          encodedUrl = `${encodedUrl}?${item}`;
        } else {
          encodedUrl = `${encodedUrl}&${item}`;
        }
      });
    }
    encodedUrl = encodeURIComponent(encodedUrl);

    let completeLoginUrl: string = `${this.configService.getApiUrl('ssoUrl')}account/login?companyCode=${companycode}`;
    if (this.externalUserId) {
      completeLoginUrl += `&userId=${this.externalUserId}`;
    }
    if (this.logintype) {
      completeLoginUrl += `&loginType=${this.logintype}`;
    }
    completeLoginUrl = `${completeLoginUrl}&returnUrl=${encodedUrl}`;

    window.location.replace(completeLoginUrl);
    return false;
  }

  fetchToken(clientcode?: string): Observable<boolean> {
    let companycode = clientcode ? clientcode : this.companycode;

    return this.getToken
      .fetchUserToken(this.token, companycode, this.previousCompanyCode)
      .pipe(
        map((resultObj: any) => {
          if (resultObj.owcUserId) {
            if (this.userInfoService._info.activeLanguage) {
              GenericClass.setCookie(
                'language',
                this.userInfoService._info.activeLanguage,
                7
              );
              this.languageService.setLanguage(
                this.userInfoService._info.activeLanguage
              );
            }

            this.cssVarsService.setVariables({
              '--Primary-active-color':
                GenericClass.getCookie('primaryColor') ||
                this.userInfoService._info.color1,
              '--secondary-color':
                GenericClass.getCookie('secondaryColor') ||
                this.userInfoService._info.color2,
            });
            //this.goToDefaultUrl();
            return true;
          } else if (
            this.queryParamCompanycode &&
            this.cookieClientCode &&
            this.queryParamCompanycode.toLowerCase() !==
              this.cookieClientCode.toLowerCase()
          ) {
            return this.validateCompanyCode(this.queryParamCompanycode);
          }
          return false;
        }),
        catchError(() => {
          const baseURL = location.href.split('?')[0];
          const redirectUrl = `${this.configService.getApiUrl('ssoUrl')}account/login?companyCode=${companycode}&returnUrl=${baseURL}`;
          window.location.replace(redirectUrl);
          return of(false); // Use 'of' to return an Observable of false.
        })
      );
  }
}

export const fetchTokenGuard: CanActivateFn = route => {
  return inject(FetchToken).canActivate(route as ActivatedRouteSnapshot);
};
